import React, { useEffect, useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "./BasicModal";
import {
	Box,
	Button,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
} from "@mui/material";
import { sizes } from "../scenarioSetupNewUtils";
import MultipleSelectChip from "./MultipleSelectChip";
import { useDispatch, useSelector } from "react-redux";
import { setState, exportSalesDataTemplateEdit, ImportSalesDataEdit } from "./editScenarioNewSlice";

const commonHeight = sizes.h35;
const SW = sizes.w300;

const dataSourceUploadButtonSx = {
	bgcolor: "darkBlue.light",
	color: "white.main",
	textTransform: "none",
	boxShadow: "none",
	"&:hover": {
		bgcolor: "darkBlue.main",
		boxShadow: "none",
	},
	"&.Mui-disabled": {
		bgcolor: "grey.lighter",
		color: "grey.main",
	},
};

export default function DefineLinkDataSources() {
	const dispatch = useDispatch();
	const [uploadedDataSourceFile, setUploadedDataSourceFile] = useState(null);
	const setupState = useSelector((store) => store.editScenarioNew);
	const { selectedDSs, selectedPDS, dataSources, editScDetails, selectedCountry } = setupState;

	useEffect(() => {
		if (editScDetails !== null) {
			// let list = [];
			// editScDetails.scenarioDatasource.forEach((item) => {
			// 	list.push(item.dataSourceName);
			// });
			// dispatch(setState("selectedDSs", list));
		}
	}, [editScDetails]);

	const handlePrimaryDataSource = (event) => {
		
		const dataSource = event.target.value;
		const id = dataSources.find(
			(source) => source.dataSourceName === dataSource
		).dataSourceID;
		dispatch(setState("selectedPDS", dataSource));
		dispatch(setState("primaryDataSourceID", id));
	};

	const handleDownloadDataSourceTemplate = () => {
		dispatch(exportSalesDataTemplateEdit());
	};

	const handleDataSourceFileSelect = (event) => {
		const fileObj = event.target.files?.[0];
		setUploadedDataSourceFile(fileObj ?? null);
	};

	const handleDataSourceFileUpload = () => {
		if (!selectedCountry || selectedCountry.length <= 0) {
			showMessage("Please select a country", "info");
			return;
		}
		if (!uploadedDataSourceFile) {
			showMessage("Please select a file", "info");
			return;
		}
		const formData = new FormData();
		formData.append("file", uploadedDataSourceFile, uploadedDataSourceFile.name);
		dispatch(
			ImportSalesDataEdit({
				countryName: selectedCountry,
				formData,
			})
		).then((result) => {
			if (result.meta?.requestStatus === "fulfilled" && result.payload === "success") {
				setUploadedDataSourceFile(null);
			}
		});
	};

	const showMessage = (message, severity) => {
		dispatch(setState("message", message));
		dispatch(setState("severity", severity));
		dispatch(setState("messageOpen", true));
	};

	const handleClearDataSourceFile = () => {
		setUploadedDataSourceFile(null);
	};

	return (
		<Grid container columns={12} justifyContent="space-between" rowSpacing={0}>
			{/* <Box sx={{ mt: 5, marginLeft:auto, }}>
				<Typography sx={{ color: "lightBlue.main", fontWeight: "bold" }} className="compHeading">
					Define and Link Data Sources
				</Typography>
			</Box> */}
			<Grid container sx={{mb: 4, mt: -.5,}}>
				<Grid item sm={8}>
					<Box>
						<MultipleSelectChip />
					</Box>
				</Grid>

				<Grid item sx={12} sm={6} md={4} lg={4}>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-end",
							mt: 2,
						}}
					>
						<Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
							<Box sx={{ mt: 2, mr: 2, width: "50%" }} md={2} lg={2}>
								<FormControl sx={{ width: "100%" }}>
									<InputLabel id="demo-simple-select-label">
										Primary Data Source
									</InputLabel>
									<Select
										labelId="demo-simple-select-label"
										id="demo-simple-select"
										value={selectedPDS}
										label="primary data sources"
										sx={{
											height: commonHeight,
											width: SW,
											color: "black.main",
											mt: 1,
										}}
										onChange={handlePrimaryDataSource}
									>
										{selectedDSs.map((source, index) => {
											return (
												<MenuItem key={index} value={source}>
													{source}
												</MenuItem>
											);
										})}
									</Select>
								</FormControl>
							</Box>
							<Box
								sx={{
									display: "flex",
									flexDirection: "row",
									justifyContent: "flex-end",
									mr: 2,
								}}
							>
								<BasicModal />
							</Box>
						</Box>
						<Grid
							container
							spacing={3}
							sx={{
								display: "flex",
								justifyContent: "flex-end",
								alignItems: "center",
								mt: 1,
								mr: 2,
							}}
						>
							<Grid item>
								<Box>
									<Button
										variant="contained"
										sx={dataSourceUploadButtonSx}
										component="span"
										onClick={handleDownloadDataSourceTemplate}
									>
										Download Template
									</Button>
								</Box>
							</Grid>
							<Grid item>
								<Box>
									<input
										type="file"
										accept=".xls,.xlsx"
										onChange={handleDataSourceFileSelect}
										style={{ display: "none" }}
										id="fileInputDataSourcesEdit"
										onClick={(e) => {
											e.target.value = null;
										}}
									/>
									<label htmlFor="fileInputDataSourcesEdit">
										<Button
											variant="contained"
											sx={dataSourceUploadButtonSx}
											component="span"
										>
											Select File
										</Button>
									</label>
								</Box>
							</Grid>
							<Grid item>
								<Box>
									<Button
										variant="contained"
										disabled={!uploadedDataSourceFile}
										sx={dataSourceUploadButtonSx}
										component="span"
										onClick={handleDataSourceFileUpload}
									>
										Upload
									</Button>
								</Box>
							</Grid>
						</Grid>
						{uploadedDataSourceFile && (
							<Box
								sx={{
									mt: 2,
									mr: 2,
									width: "100%",
									display: "flex",
									justifyContent: "flex-end",
								}}
							>
								<Box
									sx={{
										borderBottom: 0.25,
										borderColor: "#e0e0e0",
										minWidth: 200,
									}}
								>
									<div
										className="file-display"
										style={{
											display: "flex",
											justifyContent: "space-between",
											alignItems: "center",
											gap: 16,
										}}
									>
										<span>{uploadedDataSourceFile.name}</span>
										<DeleteIcon
											onClick={handleClearDataSourceFile}
											sx={{ cursor: "pointer" }}
										/>
									</div>
								</Box>
							</Box>
						)}
					</Box>
				</Grid>
			</Grid>
		</Grid>
	);
}
